<template>
  <div style="z-index: 8">
    <Titles :viewport="viewport" scene="bizTitle">
      <h1 class="title">
        <img src="../../assets/img/Logo8i2.png" alt="logo-8i" class="logo-class logo-w logo-01" />
      </h1>
    </Titles>

    <section class="scene" id="biz1">
      <div
        class="container c-titles center-content floating animation-delay-2400"
        style="z-index: -4 !important"
      >
        <div id="tag-canvas" style="width: 100%; height: 100%">
          <div id="myCanvasContainer">
            <canvas width="756" height="756" id="myCanvas" class="center-div">
              <p>Anything in here will be replaced on browsers that support the canvas element</p>
            </canvas>
          </div>
          <div id="tags" style="font-size: 50%">
            <a href="#" class="title-biz title-1 floating">INFRAESTRUCTURE</a>
            <a href="#" class="title-biz title-1 floating animation-delay-500">IT SERVICES</a>
            <a href="#" class="title-biz title-1 floating floating animation-delay-2000">INTELLIGENCE</a>
            <a href="#" class="title-biz title-1 floating floating animation-delay-1000">IMPROVEMENT</a>
            <a href="#" class="title-biz title-1 floating floating animation-delay-1600">INTEGRATION</a>
            <a href="#" class="title-biz title-1 floating floating animation-delay-700">INCREASE</a>
            <a href="#" class="title-biz title-1 floating floating animation-delay-500">INNOVATION</a>
            <a href="#" class="title-biz title-1 floating animation-delay-700">INVENTION</a>
          </div>
        </div>
      </div>

      <div class="container ">
        <img id="zen2" class="planet-img" src="../../assets/img/tierra.png" style="z-index: 2" />
      </div>
    </section>
    <section class="scene" id="biz2"></section>
    <section class="scene" id="biz3"></section>
  </div>
</template>

<script>
import Titles from "./Titles.vue";
import Containers from "@/components/Home/Containers.vue";
// import Containers from './Containers.vue';

export default {
  name: "Biz",
  props: {
    viewport: Object,
  },
  components: {
    Titles,
    Containers,
    // Containerss
  },
};
</script>
